import React, { useEffect, useState } from "react";
import {
    Card, Typography, Form, Input, InputNumber, Select, DatePicker,
    Button, Row, Col, Space, Divider, Switch, Upload, Table, Popconfirm, Flex, Segmented, AutoComplete, Tooltip,
} from "antd";
import { DeleteOutlined, PlusOutlined, InboxOutlined, FileTextOutlined, TagOutlined, InfoCircleOutlined, DollarOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import useMessage from "antd/es/message/useMessage";

import { ProjectService } from "../../../../Services/Manage/ProjectService";
import { ServicetypeService } from "../../../../Services/Manage/ServicetypeService";
import { SupplierService } from "../../../../Services/Manage/SupplierService";
import { DepartmentEmpServices } from "../../../../Services/Manage/DepartmentEmpServices";
import { UserService } from "../../../../Services/Manage/UserService";
import { ExpenseServices } from "../../../../Services/Manage/ExpenseServices";
import { ConfigurationService } from "../../../../Services/Manage/ConfigurationService";
import { InvoiceService } from "../../../../Services/Manage/InvoiceService";
import { ItemService } from "../../../../Services/Manage/ItemService";
import { StockLedgerService } from "../../../../Services/Manage/StockLedgerService";
import { ENDPOINT } from "../../../../Services/ENDPOINT";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Option, OptGroup } = Select;
const { Text, Title } = Typography;

const compactFormStyle = `
  .ant-form-item { margin-bottom: 15px !important; }
  .ant-card-body { padding: 16px 16px !important; }
  .ant-card { margin-bottom: 16px !important; }
  .ant-form-item-label { padding-bottom: 2px !important; }
  .ant-form-item-label > label { height: 20px !important; }
`;

const CardTitle = ({ icon, no, text }) => (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 8, color: "rgba(14, 93, 146, 0.95)" }}>
        {icon}
        <span style={{ fontWeight: 600 }}>{no}. {text}</span>
    </span>
);

const paymentModeOptions = [
    { value: "Cash", label: "Cash" },
    { value: "Card", label: "Card Payment" },
    { value: "Bank Transfer", label: "Bank Transfer" },
    { value: "Online Payment", label: "Online Payment" },
    { value: "Cheque", label: "Cheque" },
];


// const currencyOptions = [
//     { value: "INR", label: "INR - Indian Rupee" },
//     { value: "USD", label: "USD - US Dollar" },
//     { value: "EUR", label: "EUR - Euro" },
//     { value: "GBP", label: "GBP - British Pound" },
// ];

const approvalStatusOptions = [
    { value: "Pending", label: "Pending" },
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
];
const getPermission = (link) => {
    try {
        const raw = localStorage.getItem("ome_permission");
        const parsed = JSON.parse(raw);
        const permissions = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
        return permissions.find(p => p.link === link) || { add: false, edit: false, delete: false, read: false };
    } catch { return { add: false, edit: false, delete: false, read: false }; }
};

const CreateProEx = () => {
    const [form] = Form.useForm();
    const [message, msgContx] = useMessage();
    const navigate = useNavigate();
    const location = useLocation();
    const editBatch = location.state?.editBatch || null;
    const editProject = location.state?.project || null;
    const isEdit = !!editBatch;

    const perm = getPermission('/project-expenses');
    const viewAll = perm.view_all === true;

    const [projectOption, setProjectOption] = useState([]);
    const [vendorOption, setVendorOption] = useState([]);
    const [departmentOption, setDepartmentOption] = useState([]);
    const [selecteProId, setSelectedProId] = useState(null);
    const [userMap, setUserMap] = useState({});



    const [currencyOptions, setCurrencyOptions] = useState([]);
    const [newCurrency, setNewCurrency] = useState('');
    const [addingCurrency, setAddingCurrency] = useState(false);

    const [categoryOptions, setCategoryOptions] = useState([]);
    const [subCategoryOptions, setSubCategoryOptions] = useState([]);
    const [accountHeadOptions, setAccountHeadOptions] = useState([]);

    const [dataSource, setDataSource] = useState([]);
    const [count, setCount] = useState(1);

    const [allItems, setAllItems] = useState([]);
    const [itemSearch, setItemSearch] = useState("");
const [stockQtyMap, setStockQtyMap] = useState({});
const [otherDemandMap, setOtherDemandMap] = useState({}); // item_id -> { qty, projects: [{name, no, qty}] }

    const [fileList, setFileList] = useState([]);
    const [saving, setSaving] = useState(false);

    const isBillable = Form.useWatch("is_billable", form);
    const reimbursable = Form.useWatch("reimbursable", form);
    const discount = Form.useWatch("discount", form) || 0;
    const getAllProjects = async () => {
        try {
            const request = await ProjectService.getAllProject();
            let rows = request.data || [];

            if (!viewAll) {
                const user = await UserService.getOmeUser();
                const uid = String(user.uid).trim();

                rows = rows.filter((p) => {
                    let engineers = p.pro_engineer;
                    if (typeof engineers === "string") {
                        try { engineers = JSON.parse(engineers); } catch { engineers = []; }
                    }
                    const isEngineer = (engineers || []).some(
                        (id) => String(id).trim() === uid
                    );
                    return (
                        String(p.pro_manager ?? "").trim() === uid ||
                        String(p.added_by ?? "").trim() === uid ||
                        isEngineer
                    );
                });
            }

            // Exclude projects that already have a project expense, so a
            // project can only be picked once. Skip this when editing, so
            // the project already attached to this batch still shows.
            if (!isEdit) {
                const expenseRes = await ExpenseServices.getAllExpense();
                const groups = expenseRes?.data || [];
                const usedProjectIds = new Set(
                    groups
                        .filter((g) => g.type === "project" && g.project?.id)
                        .map((g) => Number(g.project.id))
                );
                rows = rows.filter((p) => !usedProjectIds.has(Number(p.id)));
            }

            setProjectOption(rows);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchProjectInvoice = async (project) => {
        if (!project || !project.qu_no) {
            form.setFieldsValue({ reference_no: undefined });
            return;
        }
        try {
            const request = await InvoiceService.getAllInvoice();
            const invoices = request?.data || [];
            const matched = invoices.find(
                (inv) => inv.qu_no === project.qu_no || inv.source_qu_no === project.qu_no
            );
            form.setFieldsValue({ reference_no: matched?.invoice_no || "" });
        } catch (error) {
            console.error(error);
            form.setFieldsValue({ reference_no: "" });
        }
    };

    const getUserMap = async () => {
        try {
            const request = await UserService.getAllUsers();
            const list = request?.data || [];
            const map = {};
            list.forEach((u) => {
                const uid = u.user_id || u.uid || u.id;
                if (uid) map[String(uid)] = u.name;
            });
            setUserMap(map);
        } catch (error) {
            console.error(error);
        }
    };

    // Account Head = employees belonging to any department whose name matches "Account"
    // (e.g. "Accounts", "Accounting"). department_id on a user can be a
    // comma-separated list (see CreateEmployees.jsx), so a user assigned to
    // both e.g. IT and Accounts is included too.
    const getAccountHeadOptions = async () => {
        try {
            const [deptRes, userRes] = await Promise.all([
                DepartmentEmpServices.getAllDepartment(),
                UserService.getAllUsers(),
            ]);
            const accountDeptIds = (deptRes.data || [])
                .filter((d) => (d.name || "").toLowerCase().includes("account"))
                .map((d) => String(d.id));

            const users = (userRes.data || []).filter((u) =>
                String(u.department_id || "")
                    .split(",")
                    .map((id) => id.trim())
                    .some((id) => accountDeptIds.includes(id))
            );

            setAccountHeadOptions(
                users.map((u) => ({
                    value: u.name,
                    label: `${u.name}${u.user_id ? ` (${u.user_id})` : ""}`,
                }))
            );
        } catch (error) {
            console.error(error);
        }
    };

    const getAllVendors = async () => {
        try {
            const request = await SupplierService.getAllSupplier();
            const active = (request.data || []).filter((s) => s.is_active);
            setVendorOption(active.map((item) => ({ label: item.supplier_name, value: item.id })));
        } catch (error) {
            console.error(error);
        }
    };
    // ADD (new function)
    const getAllItems = async () => {
        try {
            const request = await ItemService.getAllItem();
            const active = (request.data || []).filter((i) => i.is_active);
            setAllItems(active);
        } catch (error) {
            console.error(error);
        }
    };


const getStockQtyMap = async () => {
        try {
            const request = await StockLedgerService.getOnHandMap();
            setStockQtyMap(request.data || {});
        } catch (error) {
            console.error(error);
        }
    };

    // Demand for the same item coming from OTHER projects' saved expense
    // batches, so each project's shortfall shows only its own need instead
    // of the same combined number repeating everywhere.
    const getOtherProjectsDemand = async () => {
        try {
            const request = await ExpenseServices.getAllExpense();
            const groups = request?.data || [];
            const map = {};
            groups.forEach((g) => {
                if (g.type !== "project") return;
                if (Number(g.project?.id) === Number(selecteProId)) return;
                (g.data || []).forEach((exp) => {
                    if (exp.item_id == null) return;
                    const key = String(exp.item_id);
                    if (!map[key]) map[key] = { qty: 0, projects: [] };
                    map[key].qty += Number(exp.qty || 0);
                    map[key].projects.push({
                        name: g.project?.pro_name,
                        no: g.project?.pro_no,
                        qty: Number(exp.qty || 0),
                    });
                });
            });
            setOtherDemandMap(map);
        } catch (error) {
            console.error(error);
        }
    };

    const getAllDepartment = async () => {
        try {
            const request = await DepartmentEmpServices.getAllDepartment();
            setDepartmentOption((request.data || []).map((item) => ({ value: String(item.id), label: item.name })));
        } catch (error) {
            console.error(error);
        }
    };

    const getCurrencyOptions = async () => {
        try {
            const request = await ServicetypeService.getAllCurrency();
            const option = (request.data || []).map((item) => ({
                value: item.code,
                label: `${item.code} - ${item.name}`,
                id: item.id,
            }));
            setCurrencyOptions(option);
        } catch (error) {
            console.error(error);
        }
    };

    const getExpenseCategories = async () => {
        try {
            const request = await ConfigurationService.getByType("expense_category");
            setCategoryOptions((request.data || []).map((item) => ({ value: item.label, label: item.label })));
        } catch (error) {
            console.error(error);
        }
    };

    const getExpenseSubCategories = async () => {
        try {
            const request = await ConfigurationService.getByType("expense_sub_category");
            setSubCategoryOptions((request.data || []).map((item) => ({ value: item.label, label: item.label })));
        } catch (error) {
            console.error(error);
        }
    };

    const handleAddCurrency = async () => {
        const val = newCurrency.trim();
        if (!val) return;
        if (currencyOptions.some((c) => (c.value || '').toLowerCase() === val.toLowerCase())) {
            message.warning("Currency already exists");
            return;
        }
        try {
            setAddingCurrency(true);
            const request = await ServicetypeService.createCurrency({ code: val.toUpperCase(), name: val });
            if (request?.status) {
                await getCurrencyOptions();
                setNewCurrency('');
            } else {
                message.error(request?.message || "Failed to add currency");
            }
        } catch (error) {
            console.error(error);
            message.error("Failed to add currency");
        } finally {
            setAddingCurrency(false);
        }
    };

    const handleDeleteCurrency = async (id, value) => {
        try {
            const request = await ServicetypeService.deleteCurrency(id);
            if (request?.status) {
                setCurrencyOptions((prev) => prev.filter((c) => c.id !== id));
                if (form.getFieldValue('currency') === value) {
                    form.setFieldsValue({ currency: undefined });
                }
            } else {
                message.error(request?.message || "Failed to delete currency");
            }
        } catch (error) {
            console.error(error);
            message.error("Failed to delete currency");
        }
    };

useEffect(() => {
        getAllProjects();
        getAllVendors();
        getAllDepartment();
        getCurrencyOptions();
        getExpenseCategories();
        getExpenseSubCategories();
        getUserMap();
        getAccountHeadOptions();
        getAllItems();
        getStockQtyMap();
    }, []);

    useEffect(() => {
        getOtherProjectsDemand();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selecteProId]);


    // NEW — prefill everything when arriving in edit mode
    useEffect(() => {
        if (!editBatch || !editBatch.length) return;
        const first = editBatch[0];

        setSelectedProId(editProject?.id ?? first.project_id ?? null);

        form.setFieldsValue({
            expense_date: first.expense_date ? dayjs(first.expense_date) : null,
            payment_mode: first.payment_mode || undefined,
            reference_no: first.reference_no || "",
            category: first.category || undefined,
            sub_category: first.sub_category || undefined,
            vendor_id: first.vendor_id || undefined,
            department: first.department || undefined,
            description: first.description || "",
            discount: first.discount || 0,
            billable_to: first.billable_to || "",
            is_billable: first.is_billable === undefined ? true : !!first.is_billable,
            reimbursable: !!first.reimbursable,
            notes: first.notes || "",
            approved_by: first.approved_by || "",
            approval_date: first.approval_date ? dayjs(first.approval_date) : null,
            approved_amount: first.approved_amount || 0,
            approval_status: first.approval_status || "Pending",
            account_head: first.account_head || undefined,
            cost_center: first.cost_center || "",
            budget_head: first.budget_head || "",
            currency: first.currency || "INR",
            exchange_rate: first.exchange_rate || 1,
        });

        setDataSource(
            editBatch.map((exp, idx) =>
                recalcRow({
                    key: idx,
                    id: exp.id,
                    item_id: exp.item_id ? Number(exp.item_id) : null,
                    description: exp.description || "",
                    qty: Number(exp.qty || 0),
                    original_qty: Number(exp.qty || 0),   // NEW — qty already deducted from stock ledger
                    unitprice: Number(exp.unitprice || 0),
                    tax: Number(exp.tax || 0),
                    tax_amount: 0,
                    totalprice: Number(exp.totalprice || 0),
                })
            )
        );
        setCount(editBatch.length + 1);

        let parsedAttachments = [];
        try {
            parsedAttachments = first.attachments
                ? (typeof first.attachments === "string" ? JSON.parse(first.attachments) : first.attachments)
                : [];
        } catch { parsedAttachments = []; }

        setFileList(
            (parsedAttachments || []).map((f, idx) => ({
                uid: `existing-${idx}`,
                name: f.name || f.filename || `file-${idx}`,
                status: "done",
                url: `${ENDPOINT.base}/${f.path || f.url}`,
                ...f,
            }))
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editBatch]);

    const groupedProjects = projectOption.reduce((acc, project) => {
        let key = "Unassigned";
        if (project.pro_source === "Manual") {
            key = "Manual";
        } else if (project.qu_no) {
            key = project.pro_source === "Direct Invoice"
                ? `Direct Invoice: ${project.qu_no}`
                : `Quotation: ${project.qu_no}`;
        }
        if (!acc[key]) acc[key] = [];
        acc[key].push(project);
        return acc;
    }, {});


    // ---- Line items ----
    const recalcRow = (row) => {
        const qty = Number(row.qty || 0);
        const rate = Number(row.unitprice || 0);
        const taxPercent = Number(row.tax || 0);
        const base = qty * rate;
        const taxAmount = (base * taxPercent) / 100;
        return {
            ...row,
            tax_amount: Math.round(taxAmount * 100) / 100,
            totalprice: Math.round((base + taxAmount) * 100) / 100,
        };
    };

    // Computes the real purchase requirement for an item across the whole
    // batch (handles items appearing in multiple rows, and edit mode where
    // existing rows already deducted their own qty from the ledger).
const getItemStockInfo = (itemId) => {
        if (itemId == null) return null;
        const rawAvailable = stockQtyMap[String(itemId)] ?? 0;
        const rowsForItem = dataSource.filter((r) => Number(r.item_id) === Number(itemId));
        const sumOriginalQty = rowsForItem.reduce((s, r) => s + Number(r.original_qty || 0), 0);
        const totalDemand = rowsForItem.reduce((s, r) => s + Number(r.qty || 0), 0);
        const trueAvailable = rawAvailable + sumOriginalQty;

        const otherEntry = otherDemandMap[String(itemId)];
        const otherDemand = otherEntry?.qty || 0;
        const otherProjects = otherEntry?.projects || [];

// This project's own shortfall — drives the UI warning, so two
        // different projects no longer show an identical duplicated number.    
        // rawAvailable already has other projects' saved usage subtracted
        // (stock is deducted on save), so otherDemand must NOT be added
        // again here — that would double-count it.
        const shortfall = Math.max(totalDemand - trueAvailable, 0);
        const combinedShortfall = shortfall;

        return { rawAvailable, trueAvailable, totalDemand, shortfall, otherDemand, otherProjects, combinedShortfall };
    };

    const handleNewAdd = () => {
        setDataSource([
            ...dataSource,
            recalcRow({ key: count, description: "", qty: 1, unitprice: 0, tax: 0, tax_amount: 0, totalprice: 0 }),
        ]);
        setCount(count + 1);
    };

    const handleDelete = (record) => {
        setDataSource(dataSource.filter((item) => (item.id ?? item.key) !== (record.id ?? record.key)));
    };

    const handleChange = (identifier, field, value) => {
        setDataSource((prev) =>
            prev.map((item) =>
                (item.id ?? item.key) === identifier ? recalcRow({ ...item, [field]: value }) : item
            )
        );
    };


    const itemOptions = allItems.map((i) => ({
        value: i.id,
        label: `${i.item_name}${i.sku_barcode ? ` (${i.sku_barcode})` : ""}`,
    }));

    const handleSelectItem = (identifier, itemId) => {
        const selected = allItems.find((x) => Number(x.id) === Number(itemId));
        if (!selected) return;
        const availableQty = stockQtyMap[String(selected.id)] || 0;
        setDataSource((prev) =>
            prev.map((item) =>
                (item.id ?? item.key) === identifier
                    ? recalcRow({
                        ...item,
                        item_id: selected.id,
                        warehouse: selected.warehouse || null,
                        description: selected.item_name,
                        qty: availableQty,
                        unitprice: Number(selected.selling_price || selected.cost_price || 0),
                        tax: Number(selected.tax_rate || 0),
                    })
                    : item
            )
        );
    };

    const subTotal = dataSource.reduce((s, r) => s + Number(r.qty || 0) * Number(r.unitprice || 0), 0);
    const totalTax = dataSource.reduce((s, r) => s + Number(r.tax_amount || 0), 0);
    const totalAmount = Math.max(subTotal + totalTax - Number(discount || 0), 0);



    const columns = [
        { title: "#", width: 40, align: "center", render: (_, __, i) => i + 1 },
        {
            title: "Item / Particulars",
            dataIndex: "item_id",
            render: (value, record) => (
                <Select
                    style={{ width: "100%" }}
                    options={itemOptions}
                    value={value || undefined}
                    placeholder="Select item"
                    showSearch
                    allowClear
                    optionFilterProp="label"
                    filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                    onChange={(val) => {
                        if (!val) {
                            handleChange(record.id ?? record.key, "item_id", null);
                            handleChange(record.id ?? record.key, "description", "");
                        } else {
                            handleSelectItem(record.id ?? record.key, val);
                        }
                    }}
                />
            ),
        },
        {
            title: "Quantity",
            dataIndex: "qty",
            width: 100,
            align: "center",
            render: (text, record) => {
                const info = getItemStockInfo(record.item_id);
                const insufficient = info !== null && info.shortfall > 0;
const tooltipTitle =
                    info === null ? "" :
                        insufficient
                            ? `Total stock: ${info.rawAvailable} — this project needs ${info.totalDemand} (covers all rows using this item)` +
                              (info.otherDemand > 0 ? ` | Other projects need ${info.otherDemand} — Total PO needed: ${info.combinedShortfall}` : ` | Total PO needed: ${info.shortfall}`)
                            : `Available stock: ${info.rawAvailable}` +
                              (info.otherDemand > 0 ? ` (other projects also need ${info.otherDemand} of this item)` : "");

                return (
                    <Tooltip title={tooltipTitle}>
                        <InputNumber
                            min={0}
                            style={{ width: "100%" }}
                            status={insufficient ? "error" : undefined}
                            value={text}
                            onChange={(v) => handleChange(record.id ?? record.key, "qty", v)}
                        />
                    </Tooltip>
                );
            },
        },
        {
            title: "Rate (₹)",
            dataIndex: "unitprice",
            width: 110,
            align: "center",
            render: (text, record) => (
                <InputNumber min={0} style={{ width: "100%" }} value={text}
                    onChange={(v) => handleChange(record.id ?? record.key, "unitprice", v)} />
            ),
        },
        {
            title: "Tax (%)",
            dataIndex: "tax",
            width: 100,
            align: "center",
            render: (text, record) => (
                <Select
                    style={{ width: "100%" }}
                    value={text}
                    placeholder="Select tax"
                    onChange={(v) => handleChange(record.id ?? record.key, "tax", v)}
                    options={[0, 5, 12, 18, 28].map((t) => ({ value: t, label: `${t}%` }))}
                />
            ),
        },
        {
            title: "Tax Amount (₹)",
            dataIndex: "tax_amount",
            width: 120,
            align: "right",
            render: (text) => <Text>{Number(text || 0).toFixed(2)}</Text>,
        },
        {
            title: "Amount (₹)",
            dataIndex: "totalprice",
            width: 120,
            align: "right",
            render: (text) => <Text strong>{Number(text || 0).toFixed(2)}</Text>,
        },
        {
            title: "Action",
            width: 60,
            align: "center",
            render: (_, record) => (
                <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record)}>
                    <Button icon={<DeleteOutlined />} danger type="text" />
                </Popconfirm>
            ),
        },
    ];

    // ---- Save ----
    const handleSave = async (status = "Submitted") => {
        try {
            if (!selecteProId) {
                message.warning("Please select a project");
                return;
            }
            if (!dataSource.length) {
                message.warning("Please add at least one expense item");
                return;
            }

            setSaving(true);
            const values = form.getFieldsValue();
            const user = await UserService.getOmeUser();

            // Upload attachments on save
            const uploaded = [];
            for (const f of fileList.filter((f) => f.originFileObj)) {
                try {
                    const formData = new FormData();
                    formData.append("file", f.originFileObj);
                    const res = await fetch(`${ENDPOINT.Project}/upload-file`, { method: "POST", body: formData });
                    const result = await res.json();
                    if (result.status && result.success) uploaded.push(result.file);
                } catch (e) {
                    console.error("Attachment upload failed:", e);
                }
            }

            const commonFields = {
                project_id: selecteProId,
                added_by: user.uid,
                type: "project",
                expense_date: values.expense_date ? dayjs(values.expense_date).format("YYYY-MM-DD") : null,
                payment_mode: values.payment_mode || null,
                reference_no: values.reference_no || null,
                category: values.category || null,
                sub_category: values.sub_category || null,
                vendor_id: values.vendor_id || null,
                department: values.department || null,
                description: values.description || null,
                attachments: JSON.stringify(uploaded),
                discount: values.discount || 0,
                billable_to: values.billable_to || null,
                is_billable: !!values.is_billable,
                reimbursable: !!values.reimbursable,
                notes: values.notes || null,
                approved_by: values.approved_by || null,
                approval_date: values.approval_date ? dayjs(values.approval_date).format("YYYY-MM-DD") : null,
                approved_amount: values.approved_amount || 0,
                approval_status: status === "Draft" ? "Pending" : (values.approval_status || "Pending"),
                account_head: values.account_head || null,
                cost_center: values.cost_center || null,
                budget_head: values.budget_head || null,
                currency: values.currency || "INR",
                exchange_rate: values.exchange_rate || 1,
            };

            const formattedData = dataSource.map(({ key, tax_amount, ...rest }) => ({
                ...rest,
                ...commonFields,
            }));

            let request;
            if (isEdit) {
                const existingRows = formattedData.filter((r) => r.id);
                const newRows = formattedData.filter((r) => !r.id);

                // Any item that was in the original batch but is no
                // longer present in dataSource was deleted by the user
                // via the row's delete button — remove it on the backend too.
                const currentIds = new Set(dataSource.map((r) => r.id).filter(Boolean));
                const removedIds = (editBatch || [])
                    .map((exp) => exp.id)
                    .filter((id) => id && !currentIds.has(id));

                for (const removedId of removedIds) {
                    // eslint-disable-next-line no-await-in-loop
                    await ExpenseServices.deleteExpense(removedId);
                }

                for (const row of existingRows) {
                    const { id, ...rest } = row;
                    // eslint-disable-next-line no-await-in-loop
                    await ExpenseServices.updateExpense(rest, id);
                }
                if (newRows.length) {
                    // Stamp any newly-added rows with the original batch's
                    // added_on so they group into the same row in Manage
                    // Project Expenses, instead of appearing as a new
                    // separate project entry.
                    const batchAddedOn = editBatch?.[0]?.added_on || new Date().toISOString();
                    const stampedNewRows = newRows.map((row) => ({
                        ...row,
                        added_on: batchAddedOn,
                    }));
                    // eslint-disable-next-line no-await-in-loop
                    await ExpenseServices.createExpense(stampedNewRows);
                }
                request = { status: true, message: "Expense updated successfully" };
            } else {
                request = await ExpenseServices.createExpense(formattedData);
            }

            if (request.status) {
                await getStockQtyMap();   // NEW — refresh stock so ledger changes reflect immediately
                message.success(request.message || (isEdit ? "Expense updated successfully" : "Expense saved successfully"));
                navigate("/project-expenses");
            } else {
                message.error(request.message || "Failed to save expense");
            }
        } catch (error) {
            console.error(error);
            message.error("Something went wrong while saving");
        } finally {
            setSaving(false);
        }
    };

    const handleClose = () => {
        navigate("/project-expenses");
    };

    return (
        <>
            <style>{compactFormStyle}</style>
            {msgContx}
            <Card
                title={
                    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                        <ArrowLeftOutlined style={{ cursor: "pointer", fontSize: 18 }} onClick={handleClose} />
                        <span style={{ fontWeight: 600, fontSize: 20 }}>
                            {isEdit ? "Edit Project Expenses" : "Create Project Expenses"}
                        </span>
                        {isEdit && editBatch?.[0]?.updated_at && (
                            <span style={{ fontSize: 12, color: "#888", fontWeight: 400 }}>
                                (Last edited: {dayjs(editBatch[0].updated_at).format("DD-MM-YYYY HH:mm")})
                            </span>
                        )}
                    </span>
                }
                extra={
                    <Space>
                        <Button size="large" onClick={handleClose}>Cancel</Button>
                        {/* <Button size="large" onClick={() => handleSave("Draft")} loading={saving}>Save as Draft</Button> */}
                        <Button
                            type="primary"
                            size="large"
                            onClick={() => handleSave("Submitted")}
                            loading={saving}
                            style={{ backgroundColor: "rgba(14, 93, 146, 0.95)", borderColor: "rgba(14, 93, 146, 0.95)" }}
                        >
                            {isEdit ? "Update Expense" : "Save Expense"}
                        </Button>
                    </Space>
                }
                style={{ marginBottom: 16 }}
            >

                <Form layout="vertical" form={form} size="middle" initialValues={{ currency: "INR", exchange_rate: 1, is_billable: true, reimbursable: false, approval_status: "Pending" }}>

                    {/* 1. Expense Information */}
                    <Card title={<CardTitle icon={<FileTextOutlined />} no={1} text="Expense Information" />}>
                        <Row gutter={16}>
                            <Col xs={24} sm={12} md={6}>
                                <Form.Item label="Project" required>
                                    <Select
                                        showSearch
                                        allowClear
                                        size="large"
                                        placeholder="Select project"
                                        value={selecteProId}
                                        onChange={(val) => {
                                            setSelectedProId(val);
                                            const proj = projectOption.find((p) => p.id === val);
                                            fetchProjectInvoice(proj);
                                            form.setFieldsValue({
                                                billable_to: proj?.pro_customer || "",
                                                approved_by: userMap[String(proj?.pro_manager)] || proj?.pro_manager || "",
                                            });
                                        }}
                                        optionFilterProp="children"
                                    >
                                        {Object.keys(groupedProjects).map((groupKey) => (
                                            <OptGroup key={groupKey} label={groupKey}>
                                                {groupedProjects[groupKey].map((item) => (
                                                    <Option key={item.id} value={item.id}>
                                                        {item.pro_name} {item.pro_no ? `(${item.pro_no})` : ""}
                                                    </Option>
                                                ))}
                                            </OptGroup>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>



                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="expense_date" label="Expense Date" rules={[{ required: true, message: "Please select date" }]}>
                                    <DatePicker size="large" style={{ width: "100%" }} format="DD-MM-YYYY" placeholder="Select date" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="payment_mode" label="Payment Mode" rules={[{ required: true, message: "Please select payment mode" }]}>
                                    <Select options={paymentModeOptions} size="large" placeholder="Select payment mode" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="reference_no" label="Reference No / Invoice No.">
                                    <Input size="large" placeholder="Enter reference or invoice no." />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="category" label="Expense Category (Configuration)">
                                    <Select options={categoryOptions} size="large" showSearch allowClear placeholder="Select category" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="sub_category" label="Expense Sub Category (Configuration)">
                                    <Select options={subCategoryOptions} size="large" showSearch allowClear placeholder="Select sub category" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="vendor_id" label="Vendor / Supplier">
                                    <Select options={vendorOption} size="large" showSearch allowClear placeholder="Select vendor / supplier" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="department" label="Department">
                                    <Select options={departmentOption} size="large" showSearch allowClear placeholder="Select department" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="description" label="Description" rules={[{ required: true, message: "Please enter description" }]}>
                                    <TextArea rows={4} size="large" maxLength={500} showCount placeholder="Enter expense description..." />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item label="Attachment">
                                    <Upload.Dragger
                                        fileList={fileList}
                                        multiple
                                        accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                                        beforeUpload={(file) => {
                                            setFileList((prev) => [
                                                ...prev,
                                                { uid: `pending-${Date.now()}-${file.name}`, name: file.name, status: "done", originFileObj: file },
                                            ]);
                                            return false;
                                        }}
                                        onRemove={(file) => setFileList((prev) => prev.filter((f) => f.uid !== file.uid))}
                                    >
                                        <p className="ant-upload-drag-icon"><InboxOutlined /></p>
                                        <p className="ant-upload-text">Drag &amp; drop files here or click to upload</p>
                                        <p className="ant-upload-hint"></p>
                                    </Upload.Dragger>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>

                    {/* 2. Expense Details */}
                    <Card title={<CardTitle icon={<TagOutlined />} no={2} text="Expense Details" />}>
                        <Row gutter={16}>
                            <Col xs={24} lg={17}>
                                {(() => {
                                    const itemIds = [...new Set(dataSource.map((r) => r.item_id).filter((id) => id != null))];
                                    const shortfalls = itemIds
                                        .map((id) => ({ id, ...getItemStockInfo(id) }))
                                        .filter((x) => x.shortfall > 0);

                                    if (!shortfalls.length) return null;

                                    return (
                                        <div style={{ background: "#fff2f0", border: "1px solid #ffccc7", borderRadius: 8, padding: "10px 14px", marginBottom: 12 }}>
                                            <Text strong style={{ color: "#cf1322" }}>Purchase Order needed:</Text>
                                            <ul style={{ margin: "6px 0 0 18px", padding: 0 }}>
                                                {shortfalls.map((s) => {
                                                    const item = allItems.find((i) => Number(i.id) === Number(s.id));
                                               return (
                                                      <li key={s.id}>
                                                            {item?.item_name || `Item #${s.id}`}: this project needs <strong>{s.totalDemand}</strong>
                                                            {s.otherDemand > 0 && (
                                                                <span style={{ color: "#888" }}> (other projects need {s.otherDemand} more of this item too)</span>
                                                            )} — Total PO needed: <strong>{s.combinedShortfall}</strong>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    );
                                })()}
                                <Table
                                    dataSource={dataSource}
                                    columns={columns}
                                    pagination={false}
                                    rowKey="key"
                                    size="small"
                                />
                                <Button
                                    type="dashed"
                                    icon={<PlusOutlined />}
                                    onClick={handleNewAdd}
                                    style={{ marginTop: 12, width: "100%" }}
                                >
                                    Add Item
                                </Button>
                            </Col>

                            <Col xs={24} lg={7}>
                                <Card size="small" style={{ background: "#fafafa", height: "100%" }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                                        <Text>Sub Total (₹)</Text>
                                        <Text strong>{subTotal.toFixed(2)}</Text>
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                                        <Text>Total Tax (₹)</Text>
                                        <Text strong>{totalTax.toFixed(2)}</Text>
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                                        <Text>Discount (₹)</Text>
                                        <Form.Item name="discount" style={{ marginBottom: 0, width: 120 }}>
                                            <InputNumber min={0} style={{ width: "100%" }} />
                                        </Form.Item>
                                    </div>
                                    <Divider style={{ margin: "10px 0" }} />
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <Text strong style={{ fontSize: 15 }}>Total Amount (₹)</Text>
                                        <Text strong style={{ fontSize: 16, color: "rgba(14, 93, 146, 0.95)" }}>
                                            {totalAmount.toFixed(2)}
                                        </Text>
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    </Card>

                    {/* 3. Additional Information */}
                    <Card title={<CardTitle icon={<InfoCircleOutlined />} no={3} text="Additional Information" />}>
                        <Row gutter={16}>
                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="billable_to" label="Billable to Customer">
                                    <Input size="large" placeholder="Billable to Customer (optional)" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="is_billable" label="Is Billable">
                                    <Segmented options={[{ label: "Yes", value: true }, { label: "No", value: false }]} />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="reimbursable" label="Reimbursable">
                                    <Segmented options={[{ label: "Yes", value: true }, { label: "No", value: false }]} />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="notes" label="Notes">
                                    <TextArea rows={1} maxLength={300} showCount placeholder="Enter additional notes..." />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="approved_by" label="Approved By">
                                    <Input size="large" placeholder="Approver" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="approval_date" label="Approval Date">
                                    <DatePicker size="large" style={{ width: "100%" }} format="DD-MM-YYYY" placeholder="Select date" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="approved_amount" label="Approved Amount (₹)">
                                    <InputNumber size="large" min={0} style={{ width: "100%" }} placeholder="0.00" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="approval_status" label="Approval Status">
                                    <Select options={approvalStatusOptions} size="large" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>

                    {/* 4. Accounting Information */}
                    <Card title={<CardTitle icon={<DollarOutlined />} no={4} text="Accounting Information" />}>
                        <Row gutter={16}>
                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="account_head" label="Account Head" rules={[{ required: true, message: "Please select account head" }]}>
                                    <Select options={accountHeadOptions} size="large" showSearch allowClear placeholder="Select account head" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="cost_center" label="Cost Center">
                                    <Input size="large" placeholder="Select cost center" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="budget_head" label="Budget Head">
                                    <Input size="large" placeholder="Select budget head" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="currency" label="Currency">
                                    <Select
                                        size="large"
                                        placeholder="Select currency"
                                        options={currencyOptions}
                                        optionRender={(option) => (
                                            <Flex align="center" justify="space-between" style={{ width: "100%" }}>
                                                <span>{option.data.label}</span>
                                                <Popconfirm
                                                    title="Delete currency"
                                                    description="Are you sure you want to delete this currency?"
                                                    onConfirm={(e) => { e?.stopPropagation(); handleDeleteCurrency(option.data.id, option.data.value); }}
                                                    onCancel={(e) => e?.stopPropagation()}
                                                    okText="Yes"
                                                    cancelText="No"
                                                >
                                                    <DeleteOutlined
                                                        style={{ color: "#ff4d4f" }}
                                                        onClick={(e) => e.stopPropagation()}
                                                    />
                                                </Popconfirm>
                                            </Flex>
                                        )}
                                        dropdownRender={(menu) => (
                                            <>
                                                {menu}
                                                <Divider style={{ margin: '8px 0' }} />
                                                <Space style={{ padding: '0 8px 8px' }}>
                                                    <Input
                                                        placeholder="New currency"
                                                        value={newCurrency}
                                                        onChange={(e) => setNewCurrency(e.target.value)}
                                                        onKeyDown={(e) => e.stopPropagation()}
                                                        onPressEnter={handleAddCurrency}
                                                    />
                                                    <Button type="primary" loading={addingCurrency} onClick={handleAddCurrency}>
                                                        Add
                                                    </Button>
                                                </Space>
                                            </>
                                        )}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={6}>
                                <Form.Item name="exchange_rate" label="Exchange Rate">
                                    <InputNumber size="large" min={0} step={0.0001} style={{ width: "100%" }} />
                                </Form.Item>
                            </Col>
                        </Row>

                        {/* <div style={{ background: "#eef4fb", padding: "10px 14px", borderRadius: 8, fontSize: 13, color: "#3b6b8f" }}>
                            <b>Note:</b> Project expenses will be recorded and reflected in project costing and financial reports.
                        </div> */}
                    </Card>
                </Form>
            </Card>
        </>
    );
};

export default CreateProEx;  //new corected code 